import React from 'react';

import { SkeletonItem } from '@qality/common-components/src/atoms/SkeletonItem';

import { Table } from '../../atoms/Table';

const SKELETON_ITEM_HEIGHT = '32px';

export default function UnfinishedTestCaseExecutionsSkeletonRow() {
  return (
    <Table.Tr data-testid='unfinished-test-case-executions-skeleton-row'>
      <Table.Td>
        <Table.ContentHelper alignItems='center'>
          <SkeletonItem width='100%' height={SKELETON_ITEM_HEIGHT} hasIcon />
        </Table.ContentHelper>
      </Table.Td>
      <Table.Td>
        <Table.ContentHelper alignItems='center'>
          <SkeletonItem width='80%' height={SKELETON_ITEM_HEIGHT} />
        </Table.ContentHelper>
      </Table.Td>
      <Table.Td>
        <Table.ContentHelper alignItems='center'>
          <SkeletonItem width='60%' height={SKELETON_ITEM_HEIGHT} />
        </Table.ContentHelper>
      </Table.Td>
      <Table.Td>
        <Table.ContentHelper alignItems='center'>
          <SkeletonItem width='60%' height={SKELETON_ITEM_HEIGHT} />
        </Table.ContentHelper>
      </Table.Td>
      <Table.Td>
        <Table.ContentHelper alignItems='center'>
          <SkeletonItem
            width='0%'
            hasAvatar
            hasNoBar
            height={SKELETON_ITEM_HEIGHT}
          />
        </Table.ContentHelper>
      </Table.Td>
      <Table.Td>
        <Table.ContentHelper alignItems='center'>
          <SkeletonItem width='60%' height={SKELETON_ITEM_HEIGHT} />
        </Table.ContentHelper>
      </Table.Td>
    </Table.Tr>
  );
}
